<template>
    <div class="tags">
        <template v-if="competitor.payment.status === PAYMENT_STATUS_ONLINE_COMPLETE">
            <span class="tag is-success">
                <span>
                    <span class="icon">
                        <i class="fas fa-file-invoice-dollar"></i>
                    </span>
                    <span> {{ formatCurrencyWrapper(competitor.payment.amount, competitor.payment.currency) }}</span>
                </span>
            </span>
            <span v-if="competitor.payment.discountPercentage" class="tag is-info is-light">
                <span class="icon is-small">
                    <i class="fas fa-tag"></i>
                </span>
                <span>
                    {{ translate("coupons.payment_with_discount", false, [competitor.payment.discountPercentage]) }}
                </span>
            </span>
        </template>

        <span class="tag is-success" v-else-if="competitor.payment.status === PAYMENT_CONFIRMED_VIA_VOUCHER">
            <span class="icon">
                <i class="fas fa-star"></i>
            </span>
            <span>
                {{ translate("admin_payment.voucher") }}
            </span>
        </span>
        <span class="tag is-info" v-else-if="competitor.payment.status === PAYMENT_STATUS_ONLINE_PROCESSING">
            <span class="icon">
                <i class="fas fa-spinner fa-pulse"></i>
            </span>
            <span>
                {{ translate("admin_payment.awaiting_payment") }}
            </span>
        </span>
        <span class="tag is-danger" v-else-if="competitor.payment.status === PAYMENT_STATUS_EXPIRED">
            <span class="icon">
                <i class="fas fa-file-invoice-dollar"></i>
            </span>
            <span>
                {{ translate("admin_payment.online_expired") }}
            </span>
        </span>
        <span class="tag is-success" v-else-if="competitor.payment.is_complete && competitor.payment.amount === 0">
            <span class="icon">
                <i class="fas fa-user-edit"></i>
            </span>
        </span>
        <span class="tag is-success" v-else-if="competitor.payment.is_complete && competitor.payment.amount > 0">
            <span class="icon">
                <i class="fas fa-user-edit"></i>
            </span>
            <span>
                {{ competitor.payment.amount }}
            </span>
        </span>
        <span class="tag is-dark" v-else-if="!competitor.payment.is_complete && competitor.payment.amount > 0">
            <span class="icon">
                <i class="fas fa-user-edit"></i>
            </span>
            <span>
                {{ competitor.payment.amount }}
            </span>
        </span>
        <span class="tag is-danger" v-else-if="!competitor.payment.is_complete && competitor.payment.amount === 0 && showNonePayment">
            {{ translate("common.none") }}
        </span>
        <span class="tag is-danger" v-else-if="!competitor.payment.is_complete && !showNonePayment">
            <span class="icon">
                <i class="fa fa-exclamation-triangle" />
            </span>
        </span>
    </div>
</template>

<script setup lang="ts">
    import { formatCurrency } from "../../Common/currency";
    import { translate } from "../../Common/translations";
    import {
        PAYMENT_CONFIRMED_VIA_VOUCHER,
        PAYMENT_STATUS_EXPIRED,
        PAYMENT_STATUS_ONLINE_COMPLETE,
        PAYMENT_STATUS_ONLINE_PROCESSING,
    } from "../../Common/consts";
    import { CompetitorPaymentWithMetadata } from "../../Api/payments";

    // Props
    defineProps<{
        competitor: CompetitorPaymentWithMetadata;
        showNonePayment?: boolean;
    }>();

    function formatCurrencyWrapper(value: number, currency: string) {
        return formatCurrency(value, currency, window.panelLocale);
    }
</script>

<style scoped></style>
